// extracted by mini-css-extract-plugin
export default {"p":"_1218591570 e5d0e0372b _85a1175e7c","clr":"_0f0877c028","dls":"_67b5fee1f5"};